import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SeveritiesIndicatorComponent, TableColumn } from '@ui/aos-lib';

import { SubscriptionManagement } from '../../subscription-management.types';
import { SortBySeverityPipe } from 'src/app/shared/pipes/sort-by-severity.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SeveritiesIndicatorComponent, SortBySeverityPipe],
  template: ` <ui-severities-indicator [severities]="item.severityRules | sortBySeverity"></ui-severities-indicator> `
})
export class SubscriptionSeverityColumnComponent {
  @Input() item!: SubscriptionManagement;
  @Input() column!: TableColumn;
}
